// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__6oyEi","risk":"styles_risk__5xuzR","icon":"styles_icon__IQ0ZX","hasRisk":"styles_hasRisk__OXSb1","name":"styles_name__9Fpan"};